// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__jiHuk","rootSmall":"AddTileButton_rootSmall__KXYPj"};